module.exports = __webpack_public_path__ + "static/media/WaterfrontStationPage.a2348201.jpg";